<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex>
        <h3 class="headline grey--text text--darken-1 pt-3 pb-3" v-html="page.title_plain" />
        <div class="grey--text text--darken-1 pb-3 caption" v-if="$route.name !== 'PagePage'">Posted by
          <router-link :to="`/author/${page.author.slug}`" v-html="page.author.name" /> on {{ page.date | formatDate }}
        </div>
        <vue-adsense ad-slot="6676910020" ad-format="auto" />
        <div v-html="page.content" />
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    name: 'PageView',
    props: [
      'page'
    ]
  }
</script>


// WEBPACK FOOTER //
// src/components/PageView.vue